// SALDP white-labelling. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.
import { t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink";
import { useSetting } from "metabase/settings";

/**
 * The AGPL §13 source offer. The server refuses to start without
 * `MB_SALDP_SOURCE_URL`, so the URL is always present in a real deployment.
 */
export function useSourceCodeUrl(): string | null {
  return useSetting("saldp-source-url") || null;
}

export function SourceCodeLink({ className }: { className?: string }) {
  const url = useSourceCodeUrl();
  if (!url) {
    return null;
  }
  return (
    <ExternalLink href={url} className={className}>
      {t`Source code`}
    </ExternalLink>
  );
}
